/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpUploadsServiceApi', ($http, ApiErrorService) => {
    return {
        getUploadById: getUploadById,
        deleteUpload: deleteUpload,
        getUploadByType: getUploadByType,
        getLatestVersionUploadsByType: getLatestVersionUploadsByType,
        fileUpload: fileUpload
    };
    function getUploadById(id) {
        return $http.get(`api/UtpUploads/GetUploadById?id=${id}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteUpload(id) {
        return $http.post(`api/UtpUploads/DeleteUpload?id=${id}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getUploadByType(tblName, tblId) {
        return $http.get(`api/UtpUploads/GetUploadByType?tblName=${encodeURIComponent(tblName)}&tblId=${tblId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getLatestVersionUploadsByType(tblName, tblId) {
        return $http.get(`api/UtpUploads/GetLatestVersionUploadsByType?tblName=${encodeURIComponent(tblName)}&tblId=${tblId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function fileUpload(tblName, tblId, userId) {
        return $http.post(`api/UtpUploads/FileUpload?tblName=${encodeURIComponent(tblName)}&tblId=${tblId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
